import { VehicleApi, VehicleType, Vehicle } from '../models';

export function mapVehicleApiToVehicle(vehicleApi: VehicleApi): Vehicle {
  return {
    id: vehicleApi.id,
    description: vehicleApi.description,
    plate: vehicleApi.plateNumber,
    type: vehicleApi.vehicleType as VehicleType,
  };
}
